import $ from "jquery";

document.addEventListener("DOMContentLoaded", function () {
  (function () {
    $(".FreeConsultations").ready(function () {
      $(".FreeConsultations .schedule-call, .reschedule-call, .cancel-call").on(
        "click",
        function () {
          $(".FreeConsultations").showSpinner();
          var calendlyURL = $(this).data("calendly-url");
          Calendly.showPopupWidget(calendlyURL, function () {
            setTimeout(function () {
              location.reload();
            }, 3000);
          });
          return false;
        }
      );
    });
  })();
});
